export const LOAD_TYPE = 'Load Reducer Manager Type';
export const UNLOAD_TYPE = 'Unload Reducer Manager Type';
